module.exports = __webpack_public_path__ + "img/ccl_gallery1.4ff15d93.jpg";